import React from 'react';
import styled, { css } from 'styled-components';

import hexagonsDate from '../UI/Animations/AnimationDate/socialHexagonsDate';
import Hexagon from '../UI/Img/Hexagon';

const SocialHexagon = styled.div`
  position: relative;
  display: flex;
  width: 8rem;
  max-width: 280px;
  margin: 0;
  ${(props) => {
    const { network } = props;
    if (network === 'facebook') {
      return (css`
        top: 50%;
        left: 50%;
        transform: translate(-100%, -2%);
      `);
    }
    if (network === 'instagram') {
      return (css`
        top: 50%;
        left: 50%;
        transform: translate(0%, -102%);
      `);
    }
    return (css`
      top: 50%;
      left: 50%;
      transform: translate(-50%, -108%);
    `);
  }}
`;

const renderNetwork = (network) => {
  const dateHexagons = hexagonsDate(network);
  return (
    <SocialHexagon network={network.icon} key={network.url}>
      <a href={network.url} target="_blank" rel="noopener">
        <Hexagon
          {...dateHexagons}
        />
      </a>
    </SocialHexagon>
  );
};

const SocialSection = (props) => {
  const { networks } = props;
  return (
    <div >
      {networks.map(network => renderNetwork(network))}
    </div>
  );
};

export default SocialSection;



// WEBPACK FOOTER //
// ./src/components/Index/SocialSection.jsx